import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-center">
        <div className="footer-title">Alaiak – Mungialdeko Soinulari Elkartea</div>
        <div className="footer-location">Mungia (Bizkaia)</div>

        <div className="footer-legal-links">
          <Link to="/legal-notice">Lege-oharra</Link>
          <span className="footer-separator">|</span>
          <Link to="/privacy-policy">Pribatutasun-politika</Link>
          <span className="footer-separator">|</span>
          <Link to="/cookies-policy">Cookie-politika</Link>
        </div>
      </div>

      <div className="footer-social-networks">
        <a
          href="https://instagram.com/alaiaksoinulariak"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61554244191446&ref=_ig_profile_ac"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FaFacebook />
        </a>
        <a
          href="https://www.youtube.com/@AlaiakSoinulariak"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <FaYoutube />
        </a>
      </div>
    </footer>
  );
};

export default Footer;